import { render, staticRenderFns } from "./showEdg.vue?vue&type=template&id=dd44471c&scoped=true&"
import script from "./showEdg.vue?vue&type=script&lang=js&"
export * from "./showEdg.vue?vue&type=script&lang=js&"
import style0 from "./showEdg.vue?vue&type=style&index=0&id=dd44471c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd44471c",
  null
  
)

export default component.exports